module.exports = __webpack_public_path__ + "static/media/Rudelebel.b51be70b.jpg";